import { Typography } from "@circle-react-uikit/Typography";
import type { PaywallCheckoutPreview } from "@circle-react/types";

import { t } from "@/i18n-js/instance";

import { PreviewEntry } from "./components/PreviewEntry";
import { FirstPaymentPreview } from "./Lines/FirstPaymentPreview";
import { FuturePaymentsPreview } from "./Lines/FuturePaymentsPreview";
import { PaymentAfterTrialPreview } from "./Lines/PaymentAfterTrialPreview";
import { PaymentSchedulePreview } from "./Lines/PaymentSchedulePreview";
import { ProratedCreditPreview } from "./Lines/ProratedCreditPreview";
import { RemainingPaymentsPreview } from "./Lines/RemainingPaymentsPreview";
import { TotalDueTodayPreview } from "./Lines/TotalDueTodayPreview";
import { ModalPreviewTemplate } from "./ModalPreviewTemplate";

export interface DefaultFullPreviewProps {
  preview: PaywallCheckoutPreview;
}

export const DefaultFullPreview = Object.assign(
  ({ preview }: DefaultFullPreviewProps) => (
    <div className="flex flex-col gap-y-6 md:pt-6">
      <div className="mb-4 flex flex-row items-center">
        <Typography.LabelLg weight="semibold">
          {t("paywall_checkout.order_summary")}
        </Typography.LabelLg>
      </div>
      <FirstPaymentPreview className="pb-4" preview={preview} />
      <FuturePaymentsPreview className="py-4" preview={preview} />
      <TotalDueTodayPreview preview={preview} />
    </div>
  ),
  {
    ModalPreviewTemplate,
    FirstPaymentPreview,
    FuturePaymentsPreview,
    TotalDueTodayPreview,
    ProratedCreditPreview,
    PaymentAfterTrialPreview,
    RemainingPaymentsPreview,
    PaymentSchedulePreview,
    PreviewEntry,
  },
);
